var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbiddenCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Radio"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.37498,
    y: 0.683757,
    width: 19.25,
    height: 19.25,
    rx: 9.625,
    stroke: "#1B1A1B",
    strokeWidth: 0.916667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8893",
    x: 4.99994,
    y: 9,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#1B1A1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbiddenCircleIcon);
export default __webpack_public_path__ + "static/media/forbidden-circle-icon.38901e4928e20a6dfee7fa89b20a20a3.svg";
export { ForwardRef as ReactComponent };